import { sendByBin } from '@/shared/api/rest/oppv'

export const getPaymentState = async (iin) => {
	const response = await sendByBin({ iin: iin })
	if (response?.outRes?.code === '1') {
		return 'personal_affairs.accepted_payments'
	} else if (response?.outRes?.code === null) {
		return 'personal_affairs.empty_status'
	} else {
		return 'personal_affairs.not_accepted_payments'
	}
}
